import { BookingStates } from '../../../../../constants/booking-states';

export const isOfferState = (booking) => {
  if (
    (booking.flags || []).includes('offer') ||
    (booking.flags || []).includes('host_updated') ||
    [
      BookingStates.OFFER_SUBMITTED,
      BookingStates.OFFER_WITHDRAWN,
      BookingStates.OFFER_DECLINED,
      BookingStates.OFFER_EXPIRED
    ].includes(booking.obj_state)
  ) {
    return true;
  }
  return false;
};
